import React from 'react'
import { cx } from '@emotion/css'
import { Card } from '@offerzen/pinata-shame'
import styles from './styles'

const MessageCard = ({ children, className }) => <Card className={cx(styles.card, className)}>{children}</Card>

export default MessageCard
